import React, { useEffect, useState } from "react";
import ProcessHistory from "./process-history";

const Process = ({content}) => {
  const [index, setIndex] = useState(0);
  const services = content.subheading;
  const changeProcess = () => {
    if (index < services.length - 1){
      document.body.classList.add("no-scroll");
      setTimeout(() => {
        setIndex(index + 1)
      }, 800)
    }else{
        document.body.classList.remove("no-scroll");
    }
  }
  console.log(content)
  return (
    <section className="history-area" onWheel={changeProcess}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title white-title text-center mb-45">
              <span className="sub-title">Our Company</span>
              <h2 className="title">{content.h2}</h2>
              <p>
                {content.para}
              </p>
            </div>
          </div>
        </div>
        <div className="history-inner">
          <div className="history-img">
            <img src="/img/images/history_img.jpg" alt="" />
          </div>
          <div className="row g-0 justify-content-end">
            <div className="col-lg-6">
              <div className="history-content">
                <h2 className="title">{services[index].heading}</h2>
                <div dangerouslySetInnerHTML={{__html: services[index].para}}></div>
              </div>
            </div>
          </div>
        </div>

        {/* road map */}
        <ProcessHistory setIndex={setIndex} content={services}/>
      </div>

      <div className="history-shape-wrap">
        <img src="/img/images/history_shape01.png" alt="" />
        <img src="/img/images/history_shape02.png" alt="" />
      </div>
    </section>
  );
};

export default Process;
